import React, { useContext, PropsWithChildren, useEffect, useState } from 'react';
import useMedia from 'use-media';

import globalStyles from '../index.module.css';

export type UIMode = 'light' | 'dark';

const UIModeContext = React.createContext<UIMode>('light');

export function UIModeContextProvider({
  children,
  forceUIMode,
}: PropsWithChildren<{ forceUIMode?: UIMode }>) {
  const darkMode = useMedia('(prefers-color-scheme: dark)');
  const uiMode = forceUIMode ?? (darkMode ? 'dark' : 'light');
  const [uiModeClassApplied, setUIModeClassApplied] = useState(false);
  useEffect(() => {
    document.documentElement.classList.add(globalStyles.noAnimation);
    if (uiMode === 'light') {
      document.documentElement.classList.add(globalStyles.lightMode);
      document.documentElement.classList.remove(globalStyles.darkMode);
    } else {
      document.documentElement.classList.remove(globalStyles.lightMode);
      document.documentElement.classList.add(globalStyles.darkMode);
    }
    setTimeout(() => {
      setUIModeClassApplied(true);
      document.documentElement.classList.remove(globalStyles.noAnimation);
    }, 5);
  }, [uiMode]);
  return (
    <UIModeContext.Provider value={uiMode}>{uiModeClassApplied && children}</UIModeContext.Provider>
  );
}

export function useUIMode() {
  return useContext(UIModeContext);
}
